import React from 'react';

const SVG = ({width = '24px', height = '24px'}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Limited Icon</title>
    <g
      id="Scarcity---Original-&amp;-Limited-edition"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        transform="translate(-561.000000, -373.000000)"
        fill="#FF1749"
        fill-rule="nonzero"
        id="AB-testing"
      >
        <g transform="translate(86.000000, 277.000000)">
          <g id="Limited-edition" transform="translate(475.000000, 0.000000)">
            <g id="original-icon" transform="translate(0.000000, 96.000000)">
              <path
                d="M21.7482838,4.50343249 C22.9839817,4.50343249 23.97254,5.5194508 24,6.75514874 L24,6.75514874 L24,21.7482838 C24,22.9839817 22.9839817,24 21.7482838,24 L21.7482838,24 L6.75514874,24 C5.5194508,24 4.50343249,22.9839817 4.50343249,21.7482838 L4.50343249,21.7482838 L4.50343249,6.75514874 C4.50343249,5.5194508 5.5194508,4.50343249 6.75514874,4.50343249 L6.75514874,4.50343249 Z M21.7482838,6.01372998 L6.75514874,6.01372998 C6.34324943,6.01372998 6.01372998,6.34324943 6.01372998,6.75514874 L6.01372998,6.75514874 L6.01372998,21.7482838 C6.01372998,22.1601831 6.34324943,22.4897025 6.75514874,22.4897025 L6.75514874,22.4897025 L21.7482838,22.4897025 C22.1601831,22.4897025 22.4897025,22.1601831 22.4897025,21.7482838 L22.4897025,21.7482838 L22.4897025,6.75514874 C22.4897025,6.34324943 22.1601831,6.01372998 21.7482838,6.01372998 L21.7482838,6.01372998 Z M17.2448513,0 C18.4805492,0 19.4965675,1.01601831 19.4965675,2.25171625 L19.4965675,2.25171625 L19.4965675,2.99313501 L17.98627,2.99313501 L17.98627,2.25171625 C17.98627,1.83981693 17.6567506,1.51029748 17.2448513,1.51029748 L17.2448513,1.51029748 L2.25171625,1.51029748 C1.83981693,1.51029748 1.51029748,1.83981693 1.51029748,2.25171625 L1.51029748,2.25171625 L1.51029748,17.2448513 C1.51029748,17.6567506 1.83981693,17.98627 2.25171625,17.98627 L2.25171625,17.98627 L2.99313501,17.98627 L2.99313501,19.4965675 L2.25171625,19.4965675 C1.01601831,19.4965675 0,18.4805492 0,17.2448513 L0,17.2448513 L0,2.25171625 C0,1.01601831 1.01601831,0 2.25171625,0 L2.25171625,0 Z"
                id="Combined-Shape"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SVG;
